export default "__VITE_PUBLIC_ASSET__2d7e23d2__"